import { create } from "zustand";

interface BecomeTeacherState {
  isBecomingTeacher: boolean;
  setIsBecomingTeacher: (isOpen: boolean) => void;
}

export const useBecomeTeacherStore = create<BecomeTeacherState>((set) => ({
  isBecomingTeacher: false,
  setIsBecomingTeacher: (isOpen: boolean) => set({ isBecomingTeacher: isOpen }),
}));
